// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__sH8my","tab":"ProcedureTabs_tab__2rg44"};